import React from "react";
import { observer } from "mobx-react";
import SurveyCondensedTable from "../../../SurveyCondensedTable";
import { NumberFormat } from "../../../../Enums/constants";
import { percentPassiveCellRenderer } from "./PercentPassiveTableHandler";

const PercentPassiveTable = observer((props) => {
    return (
        <SurveyCondensedTable tableName={"PercentPassive"}
            cellRenderer={percentPassiveCellRenderer}
            styleOverride={{ marginRight: '-11%', marginBottom: '0px' }}
            class=""
            headers={["", "PpSusB", "PpSusS", "PpSnonus", "PpSemerg", "PpFbond", "PpFtip", "PpFstable", "PpFcash",
                "PpFother", "PpRcommod", "PpRreit", "PpRre", "PpP", "PpOriskpar", "PpOother"]} //, ''
            columns={[
                { data: '', readOnly: true },
                { data: 'PpSusB', className: "htRight" },
                { data: 'PpSusS', className: "htRight" },
                { data: 'PpSnonus', className: "htRight" },
                { data: 'PpSemerg', className: "htRight" },
                { data: 'PpFbond', className: "htRight" },
                { data: 'PpFtip', className: "htLeft" },
                { data: 'PpFstable', className: "htRight" },
                { data: 'PpFcash', className: "htRight" },
                { data: 'PpFother', className: "htRight" },
                { data: 'PpRcommod', className: "htRight" },
                { data: 'PpRreit', className: "htCenter" },
                { data: 'PpRre', className: "htRight" },
                { data: 'PpP', className: "htRight" },
                { data: 'PpOriskpar', className: "htLeft" },
                { data: 'PpOother', className: "htRight" },
            ]}
            formatting={['', NumberFormat.PERCENTAGE, NumberFormat.PERCENTAGE, NumberFormat.PERCENTAGE, NumberFormat.PERCENTAGE, NumberFormat.PERCENTAGE,
                NumberFormat.PERCENTAGE, NumberFormat.PERCENTAGE, NumberFormat.PERCENTAGE, NumberFormat.PERCENTAGE, NumberFormat.PERCENTAGE,
                NumberFormat.PERCENTAGE, NumberFormat.PERCENTAGE, NumberFormat.PERCENTAGE, NumberFormat.PERCENTAGE, NumberFormat.PERCENTAGE]} //, ''
            colWidths={['200px', '80px', '80px', '80px', '80px', '80px', '80px', '80px', '80px', '80px', '80px', '80px', '80px', '80px', '80px', '80px']} //, '80px'
        />
    );

});
export default PercentPassiveTable;

